import { Api } from "../api";

const api = new Api("api/communications/projects");

export const getProjects = async () => {
  const response = await api.get(
    "",
    {},
    {
      headers: { "Accept-Encoding": "gzip" },
    }
  );
  return response.data;
};
